import React, { useEffect, useState } from 'react';

// The boosters' perk: pick a name colour, and TOGΞ (the boostercolour cog) gives them a role in it. The bot checks
// they're boosting and keeps the 24 hour wait between changes: this page only shows what it says.
const PINK = '#ff73fa';
const START = '#ff73fa';

const waitText = (at) => {
  const left = Math.max(0, at - Date.now());
  const hours = Math.floor(left / 3600000);
  const minutes = Math.ceil((left % 3600000) / 60000);
  return hours ? `${hours}h ${minutes}m` : `${minutes}m`;
};

export default function BoosterColour({ ask, onClose, loggedIn = true, onLogin }) {
  const [loading, setLoading] = useState(loggedIn);
  const [state, setState] = useState(null);   // { colour, name, nextAt }
  const [colour, setColour] = useState(START);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [, tick] = useState(0);

  const errorText = (e) => ({
    login: 'Your Discord login has run out. Log in again, then try.',
    not_booster: 'This is a perk for server boosters. Boost CHΞΞKSCORD in Discord, then try again.',
    timeout: "TOGΞ didn't answer. Try again in a minute.",
  }[e] || e || "TOGΞ couldn't do that. Try again.");

  useEffect(() => {
    if (!loggedIn) return undefined;
    let cancelled = false;
    ask('booster.get', {}, 20000).then((answer) => {
      if (cancelled) return;
      if (answer.ok) {
        setState(answer.data);
        if (answer.data?.colour) setColour(answer.data.colour);
      } else {
        setError(errorText(answer.error));
      }
      setLoading(false);
    });
    return () => { cancelled = true; };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Keeps the countdown up to date while it's open
  useEffect(() => {
    if (!state?.nextAt) return undefined;
    const timer = setInterval(() => tick((n) => n + 1), 30000);
    return () => clearInterval(timer);
  }, [state?.nextAt]);

  const waiting = state?.nextAt && state.nextAt > Date.now();

  const save = async () => {
    setBusy(true);
    setError('');
    setMessage('');
    const answer = await ask('booster.save', { colour }, 25000);
    if (answer.ok) {
      setState(answer.data);
      setMessage(answer.data?.message || 'Saved!');
    } else {
      setError(errorText(answer.error));
    }
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center px-4" style={{ background: 'rgba(0,0,0,0.7)' }} onClick={onClose}>
      <div className="w-full max-w-xs rounded-xl bg-zinc-900 border p-4 shadow-2xl" style={{ borderColor: 'rgba(255,115,250,0.35)' }} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-1.5">
            <img src="/boost.png" alt="" style={{ width: '16px', height: '16px' }} />
            <h3 className="font-bold text-sm" style={{ color: PINK }}>Booster colour</h3>
          </div>
          <button onClick={onClose} className="text-zinc-400 hover:text-white text-lg leading-none" aria-label="Close">×</button>
        </div>

        {!loggedIn ? (
          // Opened from the welcome message's Booster Perks link without being logged in
          <>
            <p className="text-zinc-400 text-[11px] mb-3">Boosting CHΞΞKSCORD? Log in with Discord to pick the colour your name shows in the server.</p>
            <button
              onClick={onLogin}
              className="w-full px-2 py-2 rounded-md text-white text-xs font-semibold transition-all active:scale-95 flex items-center justify-center gap-1.5"
              style={{ background: '#5865f2' }}
            >
              <span style={{ fontSize: '12px', lineHeight: 1 }}>🔑</span>
              <span>Log in with Discord</span>
            </button>
          </>
        ) : loading ? (
          <p className="text-zinc-400 text-xs animate-pulse">Asking TOGΞ…</p>
        ) : !state ? (
          <p className="text-xs" style={{ color: '#FF6666' }}>{error}</p>
        ) : (
          <>
            <p className="text-zinc-400 text-[11px] mb-3">Thanks for boosting! Pick the colour your name shows in CHΞΞKSCORD. You can change it once every 24 hours.</p>

            {/* How it'll look in Discord */}
            <div className="rounded-lg px-3 py-2.5 mb-3" style={{ background: '#313338' }}>
              <span className="font-semibold text-sm" style={{ color: colour }}>{state.name}</span>
            </div>

            <label className="flex items-center gap-3 mb-3 cursor-pointer">
              <input
                type="color"
                value={colour}
                onChange={(e) => setColour(e.target.value)}
                disabled={waiting || busy}
                className="h-9 w-14 rounded cursor-pointer bg-transparent border-0 disabled:opacity-40"
              />
              <span className="text-white text-xs font-mono uppercase">{colour}</span>
            </label>

            {waiting ? (
              <p className="text-zinc-300 text-[11px] text-center py-1.5">You can change it again in <b className="text-white">{waitText(state.nextAt)}</b>.</p>
            ) : (
              <button
                onClick={save}
                disabled={busy || colour === state.colour}
                className="w-full px-2 py-2 rounded-md text-white text-xs font-semibold disabled:opacity-40 transition-all active:scale-95"
                style={{ background: 'linear-gradient(135deg, #ff73fa, #b845e8)' }}
              >
                {busy ? 'Saving…' : 'Save colour'}
              </button>
            )}
            {message && <p className="text-[11px] mt-2 text-center" style={{ color: '#23a55a' }}>{message}</p>}
            {error && <p className="text-[11px] mt-2 text-center" style={{ color: '#FF6666' }}>{error}</p>}
          </>
        )}
      </div>
    </div>
  );
}
